import { fuzzyDateParse } from "../../util.js";
import { parseAmount } from "../utils.js";
export function mapIblIncomeToIncome(iblIncome, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    const monthlyIncomes = iblIncome.monthlyIncome || [];
    for (const monthlyIncome of monthlyIncomes) {
        const loondienst = {
            calculationMethod: "uwvVerzekeringsbericht",
            uwvToetsinkomen: parseAmount(monthlyIncome.mitigatedIncome?.amount),
            monthlyPensionContribution: parseAmount(iblIncome.pensionContribution?.amount),
        };
        sections.loondienst ??= [];
        sections.loondienst.push({
            id: `loondienst-${globalThis.crypto.randomUUID()}`,
            sectionKey: "loondienst",
            values: loondienst,
        });
    }
    const income = {
        customerId,
        sections,
    };
    return { income, errors, warnings };
}
export function mapIncomeDocumentToIncome(incomeDoc, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    // Map income document to loondienst section
    const loondienst = {
        startDate: fuzzyDateParse(incomeDoc.documentDate).toISODate() ?? undefined,
        salaryPeriod: "jaar",
        grossSalary: parseAmount(incomeDoc.annualIncome) || 0,
        percentageForToetsinkomen: 1,
        calculationMethod: "brutoJaarsalaris",
        uwvToetsinkomen: parseAmount(incomeDoc.annualIncome) || 0,
    };
    sections.loondienst = [
        {
            id: `loondienst-${globalThis.crypto.randomUUID()}`,
            sectionKey: "loondienst",
            values: loondienst,
        },
    ];
    const income = {
        customerId,
        sections,
    };
    return { income, errors, warnings };
}
